import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { shallowEqual } from "recompose";
import Dropzone from "react-dropzone";
import { UploadClient } from "../../restClient";
import FlatButton from "material-ui/FlatButton";
import { red900, pink600, white, red500 } from "material-ui/styles/colors";
import CircularProgress from "material-ui/CircularProgress";
import Snackbar from "material-ui/Snackbar";

import RemoveCircle from "material-ui/svg-icons/action/delete";

const ERROR_MESSAGE_MAX_SIZE = "Please resize your image less then 1MB";
const ERROR_MESSAGE_FAILED = "Upload image failed";

class ImageVariantByAll extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      openSnackBar: false,
      dataImage: props.dataImage,
      message: "Please try again"
    };
  }

  handleRequestClose = () => {
    this.setState({
      openSnackBar: false
    });
  };

  convertTagsName = (name, tags) => {
    let brand = name.trim();
    let newTags = "";
    brand = brand.replace(/\s+/g, "-");
    brand = brand.replace(/[&/\\#,+[/\]()$~%.@'":*!`^?<>{}]/g, "");
    if (tags) {
      const tagsTrim = tags.map(tag => {
        return tag.trim();
      });
      newTags = tagsTrim.join("-");
      newTags = newTags.replace(/\s+/g, "-");
      //remove special character
      newTags = newTags.replace(/[&/\\#,+[/\]()$~%.@'"^:*!`?<>{}]/g, "");
    }

    let joinData = newTags === "" ? brand : brand + "-" + newTags;
    // console.log(joinData);
    return joinData;
  };

  onDrop = (accepted, rejected) => {
    if (accepted.length > 0 && rejected.length === 0) {
      this.setState({
        isLoading: true
      });

      const { nameProduct, tagsProduct } = this.props;
      let paramsCaption = this.convertTagsName(nameProduct, tagsProduct);
      const url = "/products/upload";
      let formData = new FormData();
      // caption as brand-product name
      formData.append("caption", paramsCaption);
      accepted.forEach(file => {
        formData.append("photos", file, file.name);
      });
      UploadClient(formData, url)
        .then(response => response.json())
        .then(data => {
          this.onAdd(data.url);
        })
        .catch(e => {
          this.setState({
            isLoading: false,
            openSnackBar: true,
            message: ERROR_MESSAGE_FAILED
          });
        });
    } else {
      this.setState({
        isLoading: false,
        openSnackBar: true,
        message: ERROR_MESSAGE_MAX_SIZE
      });
    }
  };

  onAdd(url) {
    const updatedFiles = [...this.state.dataImage.photos, url];
    const newDataImage = this.state.dataImage;
    newDataImage.photos = updatedFiles;
    this.setState({ dataImage: newDataImage, isLoading: false });
    this.props.onUpdatePhotos();
  }

  onRemove = file => () => {
    const filteredFiles = this.state.dataImage.photos.filter(
      stateFile => !shallowEqual(stateFile, file)
    );
    let newDataImage = this.state.dataImage;
    newDataImage.photos = filteredFiles;
    this.setState({ dataImage: newDataImage });
    this.props.onUpdatePhotos();
  };
  render() {
    const { photos } = this.state.dataImage;
    const { accept, maxSize, minSize, multiple } = this.props;
    return (
      <div>
        <DivImageBox>
          <Dropzone
            onDrop={this.onDrop}
            style={styles.dropzone}
            accept={accept}
            maxSize={maxSize}
            minSize={minSize}
            multiple={multiple}
          >
            {this.state.isLoading && (
              <div style={styles.insideBox}>
                {" "}
                <CircularProgress />{" "}
              </div>
            )}
            {!this.state.isLoading && (
              <div style={styles.insideBox}>
                <span>Drop your image file here </span>
                <span>or Click here</span>
              </div>
            )}
          </Dropzone>
          {photos &&
            photos.map((item, index) => {
              return (
                <DivImages key={index} style={styles.container}>
                  <FlatButton
                    backgroundColor={pink600}
                    hoverColor={red900}
                    style={styles.removeButton}
                    icon={<RemoveCircle color={white} />}
                    onClick={this.onRemove(item)}
                  />
                  <img
                    src={item}
                    style={styles.image}
                    alt="delete"
                    title="photos"
                  />
                </DivImages>
              );
            })}
        </DivImageBox>
        <Snackbar
          open={this.state.openSnackBar}
          message={this.state.message}
          autoHideDuration={4000}
          bodyStyle={{ backgroundColor: red500 }}
          onRequestClose={this.handleRequestClose}
        />
      </div>
    );
  }
}

const DivImageBox = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  flex-direaction: row;
  min-height: 200px;
  padding: 16px 16px 16px 16px;
  border: 4px dashed #d6d6d6;
  border-radius: 5px;
  background-color: rgba(249, 247, 244, 0.45);
`;

const DivImages = styled.div`
  width: 180px;
  height: 180px;
`;

const styles = {
  dropzone: {
    width: 180,
    height: 180,
    marginRight: 8,
    display: "flex",
    borderWidth: 2,
    borderColor: "#D6D6D6",
    borderStyle: "dashed",
    cursor: "pointer",
    borderRadius: 5
  },
  insideBox: {
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: "inherit"
  },
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    padding: 5
  },
  removeButton: {
    position: "absolute",
    top: "0.5rem",
    right: "0.5rem",
    minWidth: "2rem",
    opacity: 1
  },
  image: {
    maxHeight: "14rem",
    margin: "0.2rem",
    maxWidth: "100%"
  }
};

ImageVariantByAll.propTypes = {
  accept: PropTypes.string,
  maxSize: PropTypes.number,
  minSize: PropTypes.number,
  multiple: PropTypes.bool,
  style: PropTypes.object,
  placeholder: PropTypes.node,
  onUpdatePhotos: PropTypes.func.isRequired,
  dataImage: PropTypes.object,
  tagsProduct: PropTypes.array,
  nameProduct: PropTypes.string.isRequired
};

ImageVariantByAll.defaultProps = {
  multiple: false,
  maxSize: 1000000,
  minSize: 10,
  tagsProduct: [],
  dataImage: {
    photos: []
  }
};

export default ImageVariantByAll;



// WEBPACK FOOTER //
// ./src/components/image/ImageVariantByAll.js